module.exports = function() {
  return new Worker(__webpack_public_path__ + "7eb00a4a0d49979d9a95.worker.js");
};